import { fullComparator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getRgpdBuilders(): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'RGPD',
      'RGPD_DATE_SUPPRESSION',
      'atlasInvestisseur.dateSuppression',
      fullComparator,
      'DateTime',
      undefined
    ),
  ];
}
